.select__container {
  display: flex;
  flex-flow: column nowrap;

  & .ant-select-selector {
    width: 100%;

    padding: 12px 32px 12px 12px !important;
  }

  & .ant-select {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;

    height: unset;
  }
}

.select__container .select__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;

  white-space: nowrap;
}

.select__container .select__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}